(() => {
  const shownProducts = new Set();

  class CabinetNotice extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-cabinet-open]');
      if (!this.dialog || !this.trigger) return;

      this.trigger.addEventListener('click', () => this.open(), { signal });
      this.querySelectorAll('[data-cabinet-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), { signal });
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('zb-cabinet-modal-open');
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });

      this.frame = requestAnimationFrame(() => {
        // Quick-add previews retain the visible notice, without opening a second modal.
        if (!this.isConnected || !this.hasAttribute('data-auto-open') || shownProducts.has(this.dataset.productId)) return;
        if (this.closest('dialog, quick-add-dialog, .quick-add-modal') || !this.getClientRects().length) return;
        if (document.querySelector('dialog[open]')) return;
        this.open();
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      shownProducts.add(this.dataset.productId);
      document.documentElement.classList.add('zb-cabinet-modal-open');
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove('zb-cabinet-modal-open');
      }
      this.controller?.abort();
    }
  }

  if (!customElements.get('zentrobad-cabinet-notice')) customElements.define('zentrobad-cabinet-notice', CabinetNotice);
})();
